<template>
  <div v-if="error" class="error-boundary">
    <div class="error-content">
      <h2>Oops! Something went wrong</h2>
      <p>{{ friendlyMessage }}</p>
      <button @click="handleReset">Try Again</button>
    </div>
  </div>
  <slot v-else></slot>
</template>

<script lang="ts">
import { defineComponent, ref, onErrorCaptured } from 'vue'

export default defineComponent({
  name: 'ErrorBoundary',
  setup() {
    const error = ref<Error | null>(null)
    const friendlyMessage = ref('An unexpected error occurred.')

    onErrorCaptured((err: Error) => {
      error.value = err
      friendlyMessage.value = err.message || 'An unexpected error occurred.'
      console.error('Error captured:', err)
      return false
    })

    const handleReset = () => {
      error.value = null
      friendlyMessage.value = 'An unexpected error occurred.'
    }

    return {
      error,
      friendlyMessage,
      handleReset,
    }
  },
})
</script>

<style scoped>
.error-boundary {
  padding: 2rem;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.error-content {
  max-width: 500px;
  margin: 0 auto;
}

h2 {
  color: #dc3545;
  margin-bottom: 1rem;
}

button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: #0056b3;
}
</style>
